<as-split class="as-split" direction="horizontal" gutterSize="7" (dragEnd)="onReportViewDragEnd($event)">
  <as-split-area [size]="leftPanelWidth" [visible]="showReportView">
        <as-split class="as-split" direction="vertical" gutterSize="7">
          <as-split-area [size]="100">
            <app-report-view 
              [showContent]="isReportContentVisible"
              [isReviewTabVisible]="isReviewTabVisible"
              (unpinReportView)="onUnpinReportView($event)"
              (closeReportView)="onCloseReportView($event)">
            </app-report-view>
          </as-split-area>
        </as-split>
      </as-split-area>
      <as-split-area [size]="reportsAreaSize">
        <app-reports></app-reports>
      </as-split-area>
    </as-split>